/**
 * Bill Payment Detail container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Actions from './actions';
import BillPaymentDetail from '../../Components/BillPaymentDetail/BillPaymentDetail';
import {
  loadingSelector,
  errorSelector,
  billPaymentSelector,
} from './selectors';

const { getBillPayment } = Actions;

/**
 * Properties to be provided to the bill payment detail component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  billPayment: billPaymentSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill payment detail actions
 */
const mapDispatchToProps = (dispatch) => ({
  getBillPayment: (userId, billPaymentId) =>
    dispatch(getBillPayment(userId, billPaymentId)),
});

/**
 * Connects state to the Bill Payment component
 *
 * @param {object} mapStateToProps data object to become props for the Bill Payments component
 * @param {object} mapDispatchToProps Bill Payments actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BillPaymentDetail),
);
